/*
 * @Author: your name
 * @Date: 2022-01-07 15:30:27
 * @LastEditTime: 2022-04-20 13:08:05
 * @LastEditors: Smart Chow
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \nqc-pc-ui\src\frameworks\router\permissionRouterHook.js
 */
import store from '@/frameworks/store'
// import { Message } from "element-ui";
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from "@/common/utils/auth"; // getToken from cookie
import tokenService from '@/frameworks/auths/tokenService'
import { getUrlRootPath } from '@/common/utils/pathTools'
import { refreshTokenService } from '@/frameworks/http/request'
import eventBus from '@/frameworks/events/eventBus'
// import constants from '@/common/constants'
// import constants from '@/common/constants'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// // permission judge function
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf("admin") >= 0) return true; // admin permission passed directly
//   if (!permissionRoles) return true;
//   return roles.some(role => permissionRoles.indexOf(role) >= 0);
// }

const whiteList = [
  '/ilogin',
  '/auth-redirect',
  '/app_loading',
  '/500',
  '/test',
  '/dept_quality_control'
] // no redirect whitelist

export default function hookRegister(router) {
  // router.beforeEach((to, from, next) => {
  //   NProgress.start() // start progress bar
  //   /**
  //    * 系统加载初始化逻辑都放在了路由的beforEach钩子函数中
  //    * 1. getToken()判断是否已经登录.
  //    *  1.1 如果没有登录，则重定向到系统登录路径(系统登录路径会跳转到平台sso登录)
  //    * 2. 是否已经从服务端获取到了用户信息，菜单信息。目前用store.getters.loginUserInfo判断
  //    *  如果没有用户信息，则获取用户
  //    */
  //   console.log('dept_quality_control', to.path)
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     next()
  //     return
  //   }
  //   // 1. 如果存在token，且token未过期.
  //   if (tokenService.tokenExist() && !tokenService.tokenIsExpired()) {
  //     // 1.1 如果是刚进入系统，且还未加载登录用户的信息.
  //     if (!store.getters.loginUserInfo) {
  //       // 将当前路由缓存起来，放到重定向路径中.
  //       const redirectUrl = to.fullPath
  //       // eslint-disable-next-line object-curly-spacing
  //       next({ path: '/app_loading', query: { redirect: redirectUrl } })
  //     } else {
  //       // 1.2 继续路由过程.
  //       next()
  //     }
  //   } else if (!tokenService.tokenExist()) {
  //     next()
  //   } else if (tokenService.tokenIsExpired()) {
  //     // 如果token过期，先刷一遍token.
  //     refreshTokenService()
  //       .then((data) => {
  //         // 刷新成功继续路由
  //         next()
  //       })
  //       .catch((error) => {
  //         // 刷新token失败处理,BasicLayout有弹框提示重新登录
  //         eventBus.$emit('REFRESH_TOKEN_FAILE', error)
  //         // 中止本次路由
  //         next(false)
  //         NProgress.done()
  //       })
  //   } else {
  //     // 其他情况一样是提示认证过期，重新登录.
  //     eventBus.$emit('REFRESH_TOKEN_FAILE', {})
  //     // 中止本次路由
  //     next(false)
  //     // next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
  //     NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
  //   }
  // })

  const whiteList = ['/app_loading']
  // 读取组件中的元数据，并控制左侧导航菜单是否隐藏.
  router.beforeEach((to, from, next) => {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
      return
    }
    let userInfo = store.state.user.loginUserInfo
    if (userInfo.UserId) {
      if (from && from.matched.some((record) => record.meta.contentFillBody)) {
        store.dispatch('setContentFillBody', false)
      }
      if (to.matched.some((record) => record.meta.contentFillBody)) {
        store.dispatch('setContentFillBody', true)
      }
      next()
    } else {
      if (to.path === '/') {
        next()
      } else {
        next(false)
      }
    }
  })

  router.afterEach(() => {
    NProgress.done() // finish progress bar
  })
}
